//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { ProductMetaFieldsViewOnly } from '@campaigns/components/shared/product-details-modal/drawer/details/ProductMetaFieldsViewOnly';
import { BrandSearchField } from '@campaigns/components/shared/product-details-modal/drawer/form/BrandSearchField';
import { CategorySearchField } from '@campaigns/components/shared/product-details-modal/drawer/form/CategorySearchField';
import { EditableBVSamplingProduct } from '@campaigns/types/sampling/SamplingProductTypes';
import { FormFieldController } from '@components/form/field-controller/FormFieldController';

interface ProductMetaFieldsProps {
  isViewOnly: boolean;
}

export const ProductMetaFields = ({ isViewOnly }: ProductMetaFieldsProps) => {
  const { control, getValues } = useFormContext<EditableBVSamplingProduct>();

  if (isViewOnly) {
    const brandValue = getValues('brand');
    const categoryValue = getValues('category');

    return (
      <ProductMetaFieldsViewOnly brand={brandValue} category={categoryValue} />
    );
  }

  return (
    <Container>
      <FieldsRow>
        {/* Product Brand Field with Typeahead Search */}
        <FormFieldController control={control} name='brand'>
          {({ error, onChange, value }) => (
            <BrandSearchField
              error={error}
              onSelectBrand={onChange}
              value={value}
            />
          )}
        </FormFieldController>

        {/* Product Category Field with Typeahead Search */}
        <FormFieldController control={control} name='category'>
          {({ error, onChange, value }) => (
            <CategorySearchField
              error={error}
              onSelectCategory={onChange}
              value={value}
            />
          )}
        </FormFieldController>
      </FieldsRow>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[3]};
`;

const FieldsRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacings[3]};

  > * {
    flex: 1;
    min-width: 0;
  }
`;
